"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringValidator = void 0;
const Validator_1 = require("./Validator");
class StringValidator extends Validator_1.Validator {
    static isString(value) {
        return typeof value === 'string';
    }
    static isNotEmpty(value) {
        return !!value && value.length > 0;
    }
    static isMinLength(value, min) {
        return _a.isString(value) && _a.isNotEmpty(value) && value.length >= min;
    }
    static isMaxLength(value, max) {
        return _a.isNotEmpty(value) && value.length <= max;
    }
    static validateRegex(value, regex) {
        return regex.test(value);
    }
}
exports.StringValidator = StringValidator;
_a = StringValidator;
StringValidator.IS_STRING = () => _a.validatorFactory('IS_STRING', _a.isString);
StringValidator.NOT_EMPTY = () => _a.validatorFactory('NOT_EMPTY', _a.isNotEmpty);
StringValidator.MIN_LENGTH = (min) => _a.validatorFactory('MIN_LENGTH', value => _a.isMinLength(value, min));
StringValidator.MAX_LENGTH = (max) => _a.validatorFactory('MAX_LENGTH', value => _a.isMaxLength(value, max));
StringValidator.REGEX = (regex) => _a.validatorFactory('REGEX', value => _a.validateRegex(value, regex));
//# sourceMappingURL=StringValidator.js.map